import { useQuery, useMutation, useQueryClient } from "react-query";
import { getLookupsMachinery, getMachineryBySlug, getMachineries, saveMachinery, deleteMachinery } from "@/api/Maintainers/OA/oa-machinery-api.js";

export const key = "machineries";

export function useLookupsMachinery(enabled = true) {
	return useQuery([key, "lookups"], () => getLookupsMachinery(), { enabled });
}

export function useMachineries(filters, enabled = true) {
	return useQuery([key, "list", filters], () => getMachineries(filters), { enabled });
}

export function useMachineryBySlug(filters, slug, enabled) {
	return useQuery([key, "detail", filters, slug], () => getMachineryBySlug(filters, slug), {
		enabled: enabled,
		keepPreviousData: true,
	});
}

export function useSaveMachinery() {
	const queryClient = useQueryClient();

	return useMutation(saveMachinery, {
		onSuccess: () => {
			queryClient.invalidateQueries([key, "list"]);
		},
	});
}

export function useDeleteMachinery() {
	const queryClient = useQueryClient();

	return useMutation(deleteMachinery, {
		onSuccess: () => {
			queryClient.invalidateQueries([key, "list"]);
		},
	});
}
